import { render } from "./SdtLogo.vue?vue&type=template&id=22a9b11b"
import script from "./SdtLogo.vue?vue&type=script&lang=js"
export * from "./SdtLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__